import React from 'react';
import { FieldTemplateProps } from '@rjsf/utils';

const HorizontalFieldTemplate = ({
    id,
    label,
    help,
    required,
    description,
    errors,
    children,
    displayLabel,
    classNames,
    disabled,
    readonly,
    schema,
    uiSchema,
    onKeyChange,
    onDropPropertyClick
}: FieldTemplateProps) => {
    // Don't render anything for hidden fields
    if (uiSchema?.['ui:widget'] === 'hidden') {
        return <>{children}</>;
    }

    // Don't render horizontal layout for checkboxes, which have their own layout
    if (schema.type === 'boolean') {
        return (
            <div className={`${classNames} mb-[8px] border-b border-divider-lines last:border-b-0 pt-1 pb-[8px] last:pb-0 last:mb-0 transition-all duration-300 w-full`}>
                <div>{children}</div>
                {errors}
                {help}
                {description}
            </div>
        );
    }

    // For nested objects/arrays, use vertical layout
    if (schema.type === 'object' || schema.type === 'array') {
        return (
            <div className={`${classNames}`}>
                {displayLabel && label && <div>{label}</div>}
                <div>{children}</div>
                {errors}
                {help}
            </div>
        );
    }

    return (
        <div className={`${classNames} mb-[8px] border-b border-divider-lines last:border-b-0 pt-1 pb-[8px] last:pb-0 last:mb-0 transition-all duration-300 w-full`}>
            <div className="flex flex-row items-start justify-between w-full gap-6">
                <div className="w-1/2 flex flex-col">
                    <span className="mr-1 dark:text-white">{displayLabel && label}</span>
                    {description}
                </div>
                <div className="w-1/2">
                    <div className="p-2 dark:text-white">{children}</div>
                    {errors}
                    {help}
                </div>
            </div>
        </div>
    );
};

export default HorizontalFieldTemplate;
